import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { classes } from 'record-it-components/utils/utils';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import styles from './TimeTrackingActivityToSelectListItem.module.css';
export type TimeTrackingActivityToSelectListItemProps = PropsWithoutChildren<CardListItemProps> & {
  timeTrackingActivity: TimeTrackingActivity;
  onActivitySelected: (activity: TimeTrackingActivity) => void;
};
export const TimeTrackingActivityToSelectListItem: FunctionComponent<TimeTrackingActivityToSelectListItemProps> = React.memo(props => {
  const $ = _c(11);
  const {
    timeTrackingActivity,
    onActivitySelected,
    onClick,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const handleClick = useEventCallback(event => {
    onClick?.(event);
    onActivitySelected(timeTrackingActivity);
  });
  const T0 = CardListItem;
  const t0 = classes(className, styles.card);
  let t1;
  if ($[0] !== timeTrackingActivity.name) {
    t1 = <CardListItemTitle data-testid="TimeTrackingActivityToSelectListItem.Name">{timeTrackingActivity.name}</CardListItemTitle>;
    $[0] = timeTrackingActivity.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== timeTrackingActivity.parentActivityId) {
    t2 = timeTrackingActivity.parentActivityId == null ? <CardListItemIconButton {...iconConfigurations.prefixed.listItem.enterListItem} data-testid="TimeTrackingActivityToSelectListItem.Icon" /> : null;
    $[2] = timeTrackingActivity.parentActivityId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== T0 || $[5] !== handleClick || $[6] !== remainingProps || $[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <T0 {...remainingProps} className={t0} onClick={handleClick}>{t1}{t2}</T0>;
    $[4] = T0;
    $[5] = handleClick;
    $[6] = remainingProps;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});